/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthTokenMeta } from './AuthTokenMeta';
import {
    AuthTokenMetaFromJSON,
    AuthTokenMetaFromJSONTyped,
    AuthTokenMetaToJSON,
    AuthTokenMetaToJSONTyped,
} from './AuthTokenMeta';

/**
 * 
 * @export
 * @interface ShowTokenMetaResponse
 */
export interface ShowTokenMetaResponse {
    /**
     * 
     * @type {AuthTokenMeta}
     * @memberof ShowTokenMetaResponse
     */
    data: AuthTokenMeta;
}

/**
 * Check if a given object implements the ShowTokenMetaResponse interface.
 */
export function instanceOfShowTokenMetaResponse(value: object): value is ShowTokenMetaResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowTokenMetaResponseFromJSON(json: any): ShowTokenMetaResponse {
    return ShowTokenMetaResponseFromJSONTyped(json, false);
}

export function ShowTokenMetaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowTokenMetaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': AuthTokenMetaFromJSON(json['data']),
    };
}

  export function ShowTokenMetaResponseToJSON(json: any): ShowTokenMetaResponse {
      return ShowTokenMetaResponseToJSONTyped(json, false);
  }

  export function ShowTokenMetaResponseToJSONTyped(value?: ShowTokenMetaResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AuthTokenMetaToJSON(value['data']),
    };
}

